<m-nav-trigger
  [active]="active()"
  [open]="isOpen()"
  [disabled]="disabled()"
  [ariaLabel]="trigger().ariaLabel || trigger().label"
  [ariaHaspopup]="true"
  [ariaExpanded]="isOpen()"
  (clicked)="togglePanel($event)">
  @if (trigger().iconName) {
    <span class="trigger-icon-wrap">
      <em aria-hidden="true" class="material-symbols-outlined icon-regular">{{
        trigger().iconName
      }}</em>
      @if (showDot() && !isOpen()) {
        <span class="notification-dot" aria-hidden="true"></span>
      }
    </span>
  }
  @if (trigger().label) {
    <span class="trigger-label-wrap">
      <span class="b2 trigger-label">{{ trigger().label }}</span>
      @if (showDot() && !isOpen() && !trigger().iconName) {
        <span class="notification-dot" aria-hidden="true"></span>
      }
    </span>
  }
  <ng-content></ng-content>
  @if (!hideArrow()) {
    <em aria-hidden="true" class="material-symbols-outlined icon-small">{{
      isOpen() ? "keyboard_arrow_up" : "keyboard_arrow_down"
    }}</em>
  }
</m-nav-trigger>

<p-popover
  #popover
  mHideOnWindowScroll
  styleClass="mega-menu-panel"
  appendTo="body"
  [dismissable]="true"
  (onShow)="onShow()"
  (onHide)="onHide()">
  @if (searchable()) {
    <div class="mega-menu-search">
      <m-input-search
        class="w-50"
        [placeholder]="searchPlaceholder()"
        [ngModel]="query()"
        (ngModelChange)="query.set($event)"></m-input-search>
    </div>
  }
  <div
    class="mega-menu-grid"
    [class.cols-1]="columns() === 1"
    [class.cols-2]="columns() === 2"
    [class.cols-3]="columns() === 3"
    [style.width]="panelWidth() || null">
    @for (item of visibleItems(); track item.id ?? item.label) {
      @if (item.routerLink && !item.disabled) {
        <a
          class="mega-menu-item"
          [routerLink]="item.routerLink"
          (click)="onItemClick(item, $event)">
          <ng-container
            *ngTemplateOutlet="
              itemContent;
              context: { $implicit: item }
            "></ng-container>
        </a>
      } @else if (item.href && !item.disabled) {
        <a
          class="mega-menu-item"
          [href]="item.href"
          [attr.target]="item.target || null"
          [attr.rel]="item.target === '_blank' ? 'noopener noreferrer' : null"
          (click)="onItemClick(item, $event)">
          <ng-container
            *ngTemplateOutlet="
              itemContent;
              context: { $implicit: item }
            "></ng-container>
        </a>
      } @else {
        <button
          type="button"
          class="mega-menu-item"
          [class.is-disabled]="item.disabled"
          [disabled]="!!item.disabled"
          (click)="onItemClick(item, $event)">
          <ng-container
            *ngTemplateOutlet="
              itemContent;
              context: { $implicit: item }
            "></ng-container>
        </button>
      }
    } @empty {
      <p class="b2 mega-menu-empty">No matching items</p>
    }
  </div>
</p-popover>

<ng-template #itemContent let-item>
  @if (item.iconName) {
    <em aria-hidden="true" class="material-symbols-outlined item-icon">{{
      item.iconName
    }}</em>
  } @else if (item.iconUrl) {
    <img class="item-icon-img" [src]="item.iconUrl" alt="" />
  }
  <span class="item-text">
    <span class="item-label-row">
      @if (item.escape === false) {
        <span class="b2 item-label" [innerHTML]="item.label"></span>
      } @else {
        <span class="b2 item-label">{{ item.label }}</span>
      }
      @if (item.badge) {
        <m-badge [label]="item.badge.label"></m-badge>
      }
    </span>
    @if (item.description) {
      @if (item.escape === false) {
        <span class="c1 item-description" [innerHTML]="item.description"></span>
      } @else {
        <span class="c1 item-description">{{ item.description }}</span>
      }
    }
  </span>
</ng-template>
